import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import get from 'lodash/get'
import * as actions from './redux/actions'
import { Helmet } from 'react-helmet'
import { CircularProgress } from '@material-ui/core'
import asofix_logo_new from '../../images/asofix_logo_new.svg'
import md5 from 'md5'
import { addMenuPresupuestoUltimoEditado } from '../common/redux/addMenuPresupuestoUltimoEditado'
import { Login as BFFLogin } from '../../common/BFF/BFF_login'
import {  Presupuestador as BFFPresupuestador } from '../../common/BFF/BFF_presupuestador'
import {
  SplitLayout,
  BrandPanel,
} from './login-ui'
import { Button, Checkbox, NotificationBox, TextField } from '@asofix/core/bumper'
import { swalAlert } from '../common/swalAlert'
import { Capacitor  } from '@capacitor/core'
import { PushNotifications } from '@capacitor/push-notifications'
import { CapacitorSwipeBackPlugin } from '@notnotsamuel/capacitor-swipe-back'
import { FirebaseMessaging } from '@capacitor-firebase/messaging'
import { REACT_APP_SESSION_EXPIRES_AT_IN_MINUTES } from 'cfgCommon/config'
import { version } from '../../../package.json'
import { generateErrorObject } from 'common/utils/generateErrorObject'
import {
  FORCE_UPDATE_ERROR_MESSAGE,
  FORCE_UPDATE_ERROR_STATUS,
} from 'common/storeRedirection'


const locationInicio = Object.freeze({
  search: null,
  hash: null,
  state: null,
  pathname: '/inicio'
})
export class Login extends Component {
  static propTypes = {
    children: PropTypes.node
  }

  static defaultProps = {
    children: ''
  }

  constructor(props) {
    super(props)
    let rememberMeData = null

    const rememberMeString = localStorage.getItem('remember_me')
    if (rememberMeString) {
        rememberMeData = JSON.parse(rememberMeString)
    }

    this.state = {
      pending: false,
      error: '',
      errorEmail: '',
      checked: !!rememberMeData,
      showAlertInfo: true,
      grecaptchaToken: '',
      password: rememberMeData ? rememberMeData.p : '',
      email: rememberMeData ? rememberMeData.e : '',
      isMobileSystem: Capacitor.isNativePlatform(),
      pushToken: '',
      showPassword: false
    }

    this.handleOnChange = this.handleOnChange.bind(this)
    this.handleLogin = this.handleLogin.bind(this)
    this.redirectToAsofixSystem();
  }

  redirectToAsofixSystem = () => {
    if (localStorage.getItem('token') && Boolean(localStorage.getItem('token'))) {
      const locationToGo = this.props.location.state?.from || locationInicio.pathname
      this.props.history.push(locationToGo)
    }
  }

  UNSAFE_componentWillMount() {
    if (this.props.logout) {
      const token = localStorage.getItem('token')
      if (token) {
        if(this.props.leads.interval) clearInterval(this.props.leads.interval)
        this.props.dispatch({
          type: 'LOGOUT_USER'
        })
        BFFLogin.logout(token).catch((err) => {
          //Al deslogear otra sesion activa, el token ya no es valido en la otra sesion que se cierra y tira 401
          if(err.response.status !== 401) {
            this.props.actions.ErrorAction({
              title: 'HUBO UN ERROR AL DESLOGUEARSE'
            })
          }
        })
      }

      const error = get(this.props, 'location.state.error')
      if (error) {
        console.error('ERROR LOGIN', error)
        this.props.actions.ErrorAction({
          title: 'HUBO UN ERROR AL LOGUEARSE'
        })
      }

      this.props.history.push('/login', {
        ...this.props.location.state,
        error: null
      })
    }
  }

  handleOnChange(event) {
    if (event.target.name === 'email') {
      localStorage.removeItem('remember_me')
      this.setState({ checked: false })
    }
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  handleLogin(event) {
    event.preventDefault()

    this.setState({ error: '', pending: true })
    if (!this.state.email.includes('@')) {
      this.setState({
        errorEmail: 'La dirección debe incluír el signo @',
        pending: false
      })
    } else {
      this.enterThePage()
    }
  }

  enterThePage = (closeOtherSessions = true, trys = 2) => {
    const body = {
      email: this.state.email,
      password: md5(this.state.password),
      grecaptchaToken: this.state.grecaptchaToken,
      closeOtherSessions,
      isMobileSystem: this.state.isMobileSystem,
      pushToken: this.state.pushToken
    }

    BFFLogin.login(body).then(data => {
      if (data && data.token) {
        if (this.state.checked) {
          localStorage.setItem('remember_me', JSON.stringify({
              e: this.state.email,
              p: this.state.password, // TODO: maybe hash it
          }))
        } else {
          localStorage.removeItem('remember_me')
        }

        const now = new Date()
        const loggedUntil = now.getTime() + REACT_APP_SESSION_EXPIRES_AT_IN_MINUTES * 60 * 1000
        localStorage.setItem('logged_until', loggedUntil)

        this.props.dispatch({
          type: 'LOGIN_USER',
          profile: data.profile,
          token: data.token,
          license: {
            ...data.license,
            company: { Car_lots: [], ...data.license.company }
          },
          system: data.system,
          permissions: data.Function_Model,
          isMobileSystem: this.state.isMobileSystem
        })
        const ultimoPresupuesto = BFFPresupuestador.getPresupuestoUltimoEditado(data.profile.id);
        if(ultimoPresupuesto) {
          this.props.actions.addMenuPresupuestoUltimoEditado();
        }
        this.redirectToAsofixSystem()

      } else if(trys > 0) {
        console.log("intentoTry", trys)
        this.enterThePage(true, trys - 1)
      } else {
        this.setState({
          error: 'Error al iniciar sesión, reintentar en unos minutos',
          errorEmail: '',
          pending: false,
          showAlertInfo: true
        })
      }
    }).catch(error => {
      console.error('[error] [login]', error)
      const { statusCode, message } = generateErrorObject(error)

      if (statusCode === 401) {
        if (typeof message === 'string' && message.includes('already active sessions')) {
          this.alertSessionActive()
        } else {
          this.setState({
            error: 'El email o contraseña ingresados no son correctos',
            errorEmail: '',
            pending: false,
            showAlertInfo: true
          })
        }
      } else if (statusCode === FORCE_UPDATE_ERROR_STATUS && message === FORCE_UPDATE_ERROR_MESSAGE) {
        this.setState({
          errorEmail: '',
          pending: false
        })
      } else if (message) {
        this.setState({
          error: message,
          errorEmail: '',
          pending: false,
          showAlertInfo: true
        })
      } else {
        this.setState({
          error: 'Error no especificado',
          errorEmail: '',
          pending: false,
          showAlertInfo: true
        })
      }
    })
  }
  handleRecaptchaLoaded = () => {
    window.grecaptcha.ready(() => {
      const recaptchaBadge = document.querySelector('.grecaptcha-badge');
      if(recaptchaBadge){
        recaptchaBadge.style.visibility = 'visible';
      }
      window.grecaptcha
      .execute(process.env.REACT_APP_GOOGLE_RECAPTCHA_SITEKEY, { action: "ACCEDER" })
        .then(token => {
          this.setState({grecaptchaToken: token})
        })
    })
  }
  componentDidMount(){
    if(process.env.REACT_APP_GOOGLE_RECAPTCHA_SITEKEY){
      let script = document.getElementById('recaptcha_script');
      if(!script){
        script = document.createElement("script")
        script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_GOOGLE_RECAPTCHA_SITEKEY}`
        script.id = "recaptcha_script"
        document.body.appendChild(script)
        script.addEventListener("load", this.handleRecaptchaLoaded)
      }else{
        this.handleRecaptchaLoaded()
      }
    }else{
      this.setState({grecaptchaToken: 'provisory_token'})
      console.error('Por favor, setear la variable de entorno REACT_APP_GOOGLE_RECAPTCHA_SITEKEY')
    }
    if (this.state.isMobileSystem)
      this.registerPushNotifications()
  }
  
  componentWillUnmount(){
    const recaptchaBadge = document.querySelector('.grecaptcha-badge');
    if(recaptchaBadge){
      recaptchaBadge.style.visibility = 'hidden';
    }
    if (this.state.isMobileSystem) {
      PushNotifications.removeAllListeners()
    }
  }
  alertSessionActive = () => {
    swalAlert({
      title: 'Tu cuenta tiene una sesión abierta en otro navegador.',
      text: 'Si presionás “CONTINUAR”, se cerrará automáticamente la sesión abierta.',
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      reverseButtons: true,
      cancelButtonText: 'CANCELAR',
      confirmButtonText: 'CONTINUAR',
      customClass: {
        container: 'home-alert'
      },
      icon: 'info'
    }).then(result => {
      this.setState({
        pending: false,
      })

      if (result.isConfirmed) {
        this.enterThePage(true)
      }
      
    })
  }
  handleOnForgotPasswordClick = () => {
    this.props.history.push('/restablecer-contrasena')
  }

  onCheckBoxChange = (event) => {
    this.setState({ checked: event.target.checked })
  }

  async registerPushNotifications() {
    await this.addListeners()
    let permission = await PushNotifications.checkPermissions()
    if (permission.receive === 'prompt') permission = await PushNotifications.requestPermissions()
    if (permission.receive !== 'granted') return
    await PushNotifications.register()
  }

  async addListeners() {
    await PushNotifications.removeAllListeners()
    await PushNotifications.addListener('registration', async () => {
      const tokenFCM = await FirebaseMessaging.getToken()
      if (Capacitor.getPlatform() === 'ios') {
        await CapacitorSwipeBackPlugin.enable()
      }
      this.setState( {pushToken: tokenFCM.token} )
    })
    await PushNotifications.addListener('registrationError', (error) => {
      console.log('Error de registro', JSON.stringify(error, null, 2))
    })
  }

  render() {
    const hasError = this.state.error !== ''

    return (
        <div className="home">
            <Helmet>
                <title>Login</title>
            </Helmet>
            <SplitLayout
                brand={
                    <BrandPanel
                        logo={asofix_logo_new}
                        title="Toda tu gestión comercial,"
                        titleStrong="en un solo lugar."
                        description="Leads, catálogo, presupuestos y comisiones en un solo lugar, con IA que te asiste y te acompaña las 24 horas."
                    />
                }
            >
                <form onSubmit={this.handleLogin} className="form-section">
                    <div className="container-title">
                        <p className="login-title">Bienvenido de vuelta</p>
                        <p className="login-subtitle">Ingresá con tu cuenta</p>
                    </div>
                    {hasError && this.state.showAlertInfo && (
                      <div className="alertStuck">
                        <NotificationBox type="error" background="tinted" title={this.state.error} />
                      </div>
                    )}
                    <TextField
                        size="lg"
                        type="text"
                        name="email"
                        id="inputEmail"
                        label="Email"
                        placeholder="nombre@concesionario.com"
                        autoFocus
                        value={this.state.email}
                        onChange={this.handleOnChange}
                        disabled={this.state.pending}
                        className={hasError ? 'login-text-field--invalid' : ''}
                        error={this.state.errorEmail !== ''}
                        errorMessage={this.state.errorEmail}
                    />
                    <TextField
                        size="lg"
                        type={this.state.showPassword ? 'text' : 'password'}
                        name="password"
                        id="inputPassword"
                        label="Contraseña"
                        placeholder="••••••••"
                        value={this.state.password}
                        onChange={this.handleOnChange}
                        disabled={this.state.pending || !this.state?.email}
                        className={['login-password-field', hasError ? 'login-text-field--invalid' : ''].filter(Boolean).join(' ')}
                        suffix={
                            <button
                                type="button"
                                className="login-password-toggle"
                                onClick={() => this.setState(prev => ({ showPassword: !prev.showPassword }))}
                                onMouseDown={e => e.preventDefault()}
                                disabled={this.state.pending || !this.state?.email}
                                aria-label={this.state.showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                            >
                                <span className="material-icons-outlined" aria-hidden="true">
                                    {this.state.showPassword ? 'visibility_off' : 'visibility'}
                                </span>
                            </button>
                        }
                    />
                    <div className="remember-section">
                        <Checkbox
                            id="rememberMe"
                            name="checkedB"
                            label="Recordar mis datos"
                            checked={this.state.checked}
                            disabled={this.state.pending}
                            onChange={this.onCheckBoxChange}
                        />
                        <Button
                            variant="link"
                            size="md"
                            type="button"
                            onClick={this.handleOnForgotPasswordClick}
                        >
                            ¿Olvidaste tu contraseña?
                        </Button>
                    </div>
                    <Button
                        type="submit"
                        variant="primary"
                        size="md"
                        disabled={
                            !this.state?.password ||
                            !this.state.email ||
                            this.state.pending ||
                            !this.state.grecaptchaToken
                        }
                    >
                        Ingresar
                        {this.state.pending && (
                            <CircularProgress
                                size={20}
                            />
                        )}
                    </Button>
                </form>
                <div className="no-client-section">
                    <span className="no-client-text">
                        ¿No sos cliente de Asofix?
                    </span>
                    <Button
                        variant="link"
                        size="md"
                        type="button"
                        onClick={() => window.open('https://www.asofix.com/?login=consulta', '_blank')}
                    >
                        Solicitar asesoramiento
                    </Button>
                </div>
                <div className="version-container">
                    <span className="version-text">Versión {version}</span>
                </div>
            </SplitLayout>
        </div>
    )
  }
}

/* istanbul ignore next */
function mapStateToProps(store) {
  return {
    store,
    user: store.common.user,
    leads: store.leads
  }
}
/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...actions, addMenuPresupuestoUltimoEditado },
      dispatch
    ),
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
